import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { cookie } from '@ifeng-fe/ui_base';
import styles from './index.css';

class Layout extends React.PureComponent {
    state = {
        isCheckbox: false,
    };

    handleChange = event => {
        if (event.target.checked) {
            cookie.set('isShowPage', true);
        } else {
            cookie.set('isShowPage', false);
        }
    };

    render() {
        if (cookie.get('isShowPage')) {
            location.href = 'https://i.ifeng.com/?ch=ifengweb_2014';
        }

        return (
            <React.Fragment>
                <section className={styles.logo}>
                    <div className={styles.blogo} />
                    <div className={styles.keyword} />
                    <p className={styles.info}>
                        智能手机建议用触屏版，省流量体验佳；<br />推荐凤凰新闻客户端，热点事件早知道。
                    </p>
                </section>
                <section className={styles.btnBox}>
                    <a className={styles.borderBox} href="https://i.ifeng.com/?ch=ifengweb_2014">
                        <span className={styles.touchBox}>适合手机用户</span>
                    </a>
                    <a className={styles.borderBox} href="http://www.ifeng.com/ipad">
                        <span className={styles.pcBox}>适合PC用户</span>
                    </a>
                    <a
                        className={styles.borderBox}
                        href="http://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=5285">
                        <span className={styles.downBox} />
                    </a>
                </section>
                <label className={styles.checkBox}>
                    <input className={styles.checkBtn} name="checkbox" onChange={this.handleChange} type="checkbox" />不再显示
                </label>
            </React.Fragment>
        );
    }
}

export default errorBoundary(Layout);
